import { use } from 'react';
import { ServiceContext } from './ServiceProvider';

export type MenuService = {
  id: string;
  name: string;
  description: string;
  accessDescription: string;
  link: string;
  linkText: string;
  showInTopMenu: boolean;
  availableInCountries: string;
};

export const useServices = () => {
  const context = use(ServiceContext);

  if (!context) {
    throw Error('Wrap your app with `ServiceProvider`');
  } else {
    return { services: context.services, loading: context.loading };
  }
};
